class FortuneSavingRatio {
    id!:       number;
    month!:    number;
    year!:     number;
    earnings!: number;
    expenses!: number;
}

export default FortuneSavingRatio;